import { Suspense, useContext } from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes
} from "react-router-dom";
// internal imports
import "./App.css";
// import
import About from "./components/About";
import ContactUs from "./components/Contact";
import Home from "./components/Home";
import Landing from "./components/Landing";
import Layout from "./components/Layout";
import Login from "./components/Login";
import NotFound from "./components/NotFound";
import Service from "./components/Service";
import SignUp from "./components/SignUp";
// context API
// for use reducer
import { useAuth0 } from "@auth0/auth0-react";
import { UserContex } from "./components/App2";

function App() {
  const { state } = useContext(UserContex);
  const { isAuthenticated } = useAuth0();

  /*----------premitionTo Home------------*/

  const premitionTohome =
    state || isAuthenticated ? (
    <Home/>
    ) : (
      <Navigate to="/login" />
    );
  /*----------premitionTo Reg------------*/
  const premitionToReg =
    state || isAuthenticated ? <Navigate to="/home" /> : <SignUp />;
  /*----------premitionTo Login------------*/
  const premitionToLogin =
    state || isAuthenticated ? <Navigate to="/home" /> : <Login />;
  return (
    <>
      <Suspense fallback="Loading..">
        <Router>
          <Layout>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={premitionToLogin} />
              <Route path="/reg" element={premitionToReg} />
              <Route path="/home" element={premitionTohome} />
              <Route path="/service" element={<Service />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
        </Router>
      </Suspense>
    </>
  );
}

export default App;
